let resetTimeOutId;
let animationTimeOut;

class PowerOfGodsGameService {
  onGetInitialStateResult() {}

  doSpin() {}

  handleDoSpinResult() {}

  clearAutoBetTimeOut() {
    clearTimeout(resetTimeOutId);
    clearTimeout(animationTimeOut);
  }

  resetAutoBetState() {}

  resetGameData() {}
}

export const powerOfGodsGameService = new PowerOfGodsGameService();
